import { ReactNode, useMemo, useReducer } from 'react';

import { EntityContext, entityReducer, EntityState } from 'Screens/Dashboard/AllEntities/EntityProvider/EntityContext';
import useGetUser from 'hooks/useGetUser';

const predefinedTags = [
    { name: 'Ksiądz', isRequired: true },
    { name: 'Gość', isRequired: true },
    { name: 'Ministrant', isRequired: true },
    { name: 'Zakonnica', isRequired: true },
    { name: 'Lektor', isRequired: true },
];

const baseInitialState: EntityState = {
    name: '',
    email: '',
    phoneNumber: '',
    website: '',
    tags: predefinedTags,
    isSubgroup: false,
    parentId: null,
    usesPoints: true,
    isIndependent: false,
    isEdit: false,
};

export const AddEntityProvider = ({
    children,
    isParishCreation = false,
}: {
    children: ReactNode;
    isParishCreation?: boolean;
}) => {
    const user = useGetUser();
    const parishId = useMemo(
        () => (user?.entities ?? []).find((entity) => entity.isParish)?.id ?? null,
        [user],
    );
    const initialState = useMemo(() => ({
        ...baseInitialState,
        tags: isParishCreation ? [] : predefinedTags,
        isSubgroup: !isParishCreation && Boolean(parishId),
        parentId: !isParishCreation ? parishId : null,
    }), [isParishCreation, parishId]);
    const [state, dispatch] = useReducer(entityReducer, initialState);
    const value = useMemo(() => ({ state, dispatch }), [state, dispatch]);

    return (
        <EntityContext.Provider value={value}>
            {children}
        </EntityContext.Provider>
    );
};
